<template>
  <div>
    <div>
      <div class="comment" v-for="(item,index) in commentList">
        <!--<div class="common-avatar J_User">-->
          <!--<img src="" width="100%" height="100%">-->
        <!--</div>-->
        <div class="comment-block"><p class="comment-user"><span
          class="comment-username J_User"> {{item.user}} </span> <span class="comment-time">{{item.createTime}}</span>
        </p>
          <div class="comment-content J_CommentContent">{{item.content}}</div>
          <!--评论回复-->
          <!--<div class="reply J_ReplyBlock">-->
          <!--<div class="reply-block">-->
          <!--<div class="reply-content"><span class="reply-user">-->
          <!--<b class="reply-user-nick J_User">S🅰♏️ue</b>  : </span>-->
          <!--面对错综复杂的国内外形势，党中央统筹国内国际两个大局、发展安全两件大事，就加强公安工作作出一系列重大决策部署，实施一系列重大改革举措，全面深化公安改革，全面推进从严管党治警，提升公安机关执法公信力，促进了社会公平正义，增强了人民群众安全感，确保了社会大局稳定。-->
          <!--</div>-->
          <!--<div class="reply-operate reply-operate&#45;&#45;hot" >-->
          <!--<span class="J_Vote reply-operate-item reply-up">赞<i>5</i></span> <i class="reply-dot">·</i> <span-->
          <!--class="J_Reply reply-operate-item" id="J_Reply6532049753606773569" data-nick="S🅰♏️ue"-->
          <!--data-userid="56163683">回复</span> <i class="reply-dot">·</i> <span>47分钟前</span> <i-->
          <!--class="reply-dot reply-operate-report">·</i> <span-->
          <!--class="reply-operate-item reply-operate-report J_ReplyReport" id="J_ReplyReport6532049753606773569"-->
          <!--data-userid="56163683" data-targetid="3877493293" data-id="6532049753606773569">举报</span></div>-->
          <!--</div>-->
          <!--<div class="reply-block">-->
          <!--<div class="reply-content"><span class="reply-user">-->
          <!--<b class="reply-user-nick J_User" data-userid="588112520">深圳金融从业者(David.zhang)</b>  : </span>-->
          <!--</div>-->
          <!--<div class="reply-operate reply-operate&#45;&#45;hot" data-id="6531889135656398767" data-targetid="3877493293">-->
          <!--<span class="J_Vote reply-operate-item reply-up">赞<i>14</i></span> <i class="reply-dot">·</i> <span-->
          <!--class="J_Reply reply-operate-item" id="J_Reply6531889135656398767" data-nick="深圳金融从业者(David.zhang)"-->
          <!--data-userid="588112520">回复</span> <i class="reply-dot">·</i> <span>11小时前</span> <i-->
          <!--class="reply-dot reply-operate-report">·</i> <span-->
          <!--class="reply-operate-item reply-operate-report J_ReplyReport" id="J_ReplyReport6531889135656398767"-->
          <!--data-userid="588112520" data-targetid="3877493293" data-id="6531889135656398767">举报</span></div>-->
          <!--</div>-->
          <!--<div class="J_ReplyLatest"></div>-->
          <!--<span class="reply-allBtn J_ReplyMoreBtn" data-targetid="3877493293" data-id="6531878864030325639"-->
          <!--data-replyhotid="6532049753606773569|6531889135656398767|"> 查看全部40条回复 </span></div>-->

        </div>
        <div class="comment-operate J_CommentOperate clearfix">
          <span class="J_Vote comment-operate-item comment-operate-up"><i>{{item.likes}}</i></span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import axios from '../../axios/index'

  export default {
    name: "comment",
    props: ['commentList'],
    data() {
      return {}
    },

    created: function () {

    },
    methods: {}
  }


</script>

<style scoped>
  .comment {
    position: relative;
    margin-top: 32px;
    padding: 0 0 32px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .common-avatar {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 50px;
    height: 50px;
    font-size: 0;
    border-radius: 50%;
    background: 0 0 no-repeat;
    overflow: hidden;
  }

  .common-avatar img {
    width: 100%;
    height: 100%;
  }

  .comment-user {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
  }

  .comment-username {
    font-weight: 600;
    color: #379be9;
  }

  .comment-time {
    color: #999;
    display: inline-block;
    margin-left: 12px;
  }

  .comment-short .comment-content {
    margin-top: 2px;
  }

  .comment-content {
    font-size: 14px;
    color: #4b4b4b;
    line-height: 24px;
    margin-top: 10px;
    word-wrap: break-word;
  }

  .reply {
    background-color: #f7f7f7;
    padding: 8px 16px 24px;
    margin-top: 10px;
  }

  .reply-block {
    position: relative;
  }

  .reply-content {
    font-size: 14px;
    color: #4b4b4b;
    line-height: 24px;
    margin-top: 10px;
  }

  .reply-user {
    color: #4b4b4b;
  }

  .reply-user-nick {
    font-weight: 600;
  }

  .reply-operate--hot {
    padding-left: 20px;
    background: url(../../assets/comment-icon.png) 0 -104px no-repeat;
  }

  .reply-operate span {
    color: #adadad;
  }

  .reply-operate-item {
    cursor: pointer;
  }

  .reply-allBtn {
    font-size: 14px;
    color: #adadad;
    display: inline-block;
    padding-right: 10px;
    height: 16px;
    line-height: 16px;
    background: url(../../assets/comment-icon.png) right -88px no-repeat;
    margin-top: 14px;
    cursor: pointer;
  }
  .comment-operate {
    margin-top: 18px;
    font-size: 12px;
  }

  .comment-operate-item {
    float: left;
    position: relative;
    width: 72px;
    padding-left: 16px;
    height: 14px;
    line-height: 14px;
    background-image: url(../../assets/comment-icon.png);
    background-repeat: no-repeat;
    color: #adadad;
    cursor: pointer;
    font-size: 14px;
  }
  .comment-operate-up {
    background-position: 0 -18px;
  }
  .comment-operate-reply {
    background-position: 0 -46px;
  }


</style>



// WEBPACK FOOTER //
// src/components/comment/comment.vue